import React from 'react';
import '../Popup.scss';

class Popup extends React.Component {
  render() {
    const { onOkClick, okText } = this.props;
    return (
      <div className="popup_inner">
        <span className="warn warning" />
        <span className="popup_inner_title">{this.props.text}</span>
        <span className="popup_inner_content">{this.props.textContent}</span>

        {onOkClick && (
          <div className="d-flex justify-content-end">
            <div className="btn btn-cus-nomal bg-b-color-3" onClick={onOkClick}>
              {okText || 'Ok'}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Popup;
